// Product card colour swatches (snippets/card-swatches.liquid): swap the card photo and link to the chosen variant.
document.addEventListener('click', (event) => {
  const swatch = event.target.closest('[data-card-swatches] button[data-swatch-url]');
  if (!swatch) return;
  const card = swatch.closest('li') || swatch.closest('s-view-event');
  if (!card) return;

  swatch.parentElement.querySelectorAll('button[aria-pressed]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
  swatch.setAttribute('aria-pressed', 'true');

  const url = swatch.dataset.swatchUrl;
  card.querySelectorAll('a[href]').forEach((link) => {
    if (link.closest('[data-card-swatches]')) return;
    if (!link.dataset.productUrl) link.dataset.productUrl = link.getAttribute('href').split('?')[0];
    if (url.split('?')[0] === link.dataset.productUrl) link.setAttribute('href', url);
  });

  const image = swatch.dataset.swatchImage;
  const img = card.querySelector('a img');
  if (image && img) {
    img.removeAttribute('loading');
    img.srcset = swatch.dataset.swatchSrcset || '';
    img.src = image;
  }
});
